import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';


@Component({
  selector: 'enable-popup',
  templateUrl: './enable-popup.component.html',
  styleUrls: ['./enable-popup.component.less', '../../shared/common.less']
})
export class EnablePopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() enableEvent = new EventEmitter<boolean>();
  @Input() contactToEnable: string = "";
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  onEnable() {
    this.enableEvent.emit(true);
  }

  ngOnInit() {}

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

}
